import {
  COST_STRATEGY,
  STRATEGY_CHOSEN,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

export const getCostStrategy = (
  strategyChosen: string | undefined,
  dsCostPremiumPct: number | undefined
) => {
  if (strategyChosen === STRATEGY_CHOSEN.spotControl) {
    return COST_STRATEGY.defaultSpotControlPanelConfigs
  }
  if (strategyChosen === STRATEGY_CHOSEN.strikePrice) {
    return COST_STRATEGY.automatedStrikePrice
  }
  if (
    strategyChosen?.toLowerCase() === STRATEGY_CHOSEN.revenuePlusMargin.toLowerCase() &&
    dsCostPremiumPct === 0
  ) {
    return COST_STRATEGY.bidAtCost
  }
  return COST_STRATEGY.other
}
